/* global jQuery */
import Isotope from "isotope-layout";

/**
 * At the of writing this, this activates filtering for the following blocks:
 * - kehittamo/block-contact-list
 * - kehittamo/block-reference-list
 */

(($) => {
  // Filters components based on provided selected filters.
  const filterComponents = ({ grid, selectedFilters }) => {
    const filtersTotal = Object.values(selectedFilters).reduce(
      (len, filterValue) => len + filterValue.length,
      0,
    );

    grid.arrange({
      filter() {
        if (filtersTotal === 0) {
          return true;
        }
        const $item = $(this);
        const data = $item.data("isotope-item");
        if (!data) {
          return false;
        }
        if (
          // At least one from each selected meta's values must hit.
          Object.entries(selectedFilters).every(
            ([filterName, filterValues]) =>
              Object.hasOwnProperty.call(data, filterName) &&
              filterValues.some((filterValue) =>
                data[filterName].includes(filterValue),
              ),
          )
        ) {
          return true;
        }
        return false;
      },
    });
  };

  $(() => {
    // Activate filtering for each component.
    $(".js-isotope-root").each((i, rootElement) => {
      const $root = $(rootElement);
      const $grid = $root.find(".js-isotope-grid").eq(0);
      const gridElement = $grid[0];
      const firstNarrowItem = $grid.find(".is-narrow")[0];

      const grid = new Isotope(gridElement, {
        layoytMode: "masonry",
        masonry: {
          gutter: 0,
          columnWidth: firstNarrowItem,
        },
      });

      const selectedFilters = $grid.data("isotope-preselected-filters") || {};

      // Filter grid at load if filters are preselected.
      filterComponents({ grid, selectedFilters });

      setTimeout(() => {
        $grid.removeClass("is-loading");
      }, 400);

      // Filter button logic
      $root.find(".js-isotope-filters").on("click", "button", function () {
        const $this = $(this);
        const { metaName, metaValue } = $this.data();
        // Show all items if no filters selected.
        if (!Object.hasOwnProperty.call(selectedFilters, metaName)) {
          selectedFilters[metaName] = [];
        }
        // Check if we're toggling off (or on) a filter.
        const removeIdx = selectedFilters[metaName].indexOf(metaValue);
        if (removeIdx !== -1) {
          $this.removeClass("is-active");
          selectedFilters[metaName].splice(removeIdx, 1);
          if (!selectedFilters[metaName].length) {
            delete selectedFilters[metaName];
          }
        } else {
          $this.addClass("is-active");
          selectedFilters[metaName].push(metaValue);
        }
        // Do the filtering
        filterComponents({ grid, selectedFilters });
      });
    });
  });
})(jQuery);
